export default __webpack_public_path__ + "locales/sr-Cyrl-RS/HotkeysPanel.json?hash=d92e3aceb565d1fd0e131c1427e579dd";